import { SET_EXPORTS, SET_EXPORT } from './actiontypes';
import {
  getExports,
  createExport,
  patchExport,
  refreshExportLinks,
  selectPoints,
} from '../../api/Api';
import { sendData } from './util';

export const fetchExportsAction = () => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return getExports(jwt).then((data) => dispatch(sendData(SET_EXPORTS, data)));
};

export const createExportAction = (data) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return createExport(jwt, data).then((res) => dispatch(sendData(SET_EXPORT, res)));
};

export const modifyExportAction = (id, data) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return patchExport(jwt, id, data).then((res) => dispatch(sendData(SET_EXPORT, res)));
};

export const refreshExportLinksAction = (id) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return refreshExportLinks(jwt, id).then((res) => dispatch(sendData(SET_EXPORT, res)));
};

export const selectPointsAction = (selector) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return selectPoints(jwt, selector);
};
